export const columns = [
  { id: "SNo", label: "SNo" },
  {
    id: "ProgrammeName",
    label: "Programme Name",
    minWidth: 170,
    align: "center",
  },
  {
    id: "ProgrammeCode",
    label: "Programme Code",
    minWidth: 170,
    align: "center",
  },
  {
    id: "Course",
    label: "Course Type",
    minWidth: 170,
    align: "center",
  },
  {
    id: "Duration",
    label: "Duration",
    minWidth: 170,
    align: "center",
  },
];

export const rows = [
  {
    SNo: "1",
    ProgrammeName: "Civil Engineering",
    ProgrammeCode: "01",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "2",
    ProgrammeName: "Electrical & Electronics Engineering",
    ProgrammeCode: "02",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "3",
    ProgrammeName: "Mechanical Engineering",
    ProgrammeCode: "03",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "4",
    ProgrammeName: "Electronics and Communication Engineering",
    ProgrammeCode: "04",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "5",
    ProgrammeName: "Computer Science Engineering",
    ProgrammeCode: "05",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "6",
    ProgrammeName: "Chemical Engineering",
    ProgrammeCode: "08",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "7",
    ProgrammeName: "Information Technology",
    ProgrammeCode: "12",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "8",
    ProgrammeName: "Computer Science and Systems Engineering",
    ProgrammeCode: "15",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "9",
    ProgrammeName: "Bio- Technology",
    ProgrammeCode: "23",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "10",
    ProgrammeName: "Automobile Engineering",
    ProgrammeCode: "24",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "11",
    ProgrammeName: "CSE( Artificial Intelligence)",
    ProgrammeCode: "43",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "12",
    ProgrammeName: "CSE( Data Science)",
    ProgrammeCode: "44",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "13",
    ProgrammeName: "CSE (Artificial Intelligence and Data Science)",
    ProgrammeCode: "45",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "14",
    ProgrammeName: "CSE ( Cyber Security)",
    ProgrammeCode: "46",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "15",
    ProgrammeName: "CSE( Internet of Things)",
    ProgrammeCode: "49",
    Course: "B.Tech",
    Duration: "4 Years",
  },
  {
    SNo: "16",
    ProgrammeName: "Environmental Engineering & Management",
    ProgrammeCode: "01",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "17",
    ProgrammeName: "Renewable Energy",
    ProgrammeCode: "02",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "18",
    ProgrammeName: "Bio-Technology",
    ProgrammeCode: "03",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "19",
    ProgrammeName: "CAD/CAM",
    ProgrammeCode: "04",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "20",
    ProgrammeName: "Computer Science",
    ProgrammeCode: "05",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "21",
    ProgrammeName: "Petroleum Engineering",
    ProgrammeCode: "08",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "22",
    ProgrammeName: "Power Electronics & Systems",
    ProgrammeCode: "12",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "23",
    ProgrammeName: "Machine Design",
    ProgrammeCode: "15",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "24",
    ProgrammeName: "Highway Engineering",
    ProgrammeCode: "23",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "25",
    ProgrammeName: "Material Science & Technology",
    ProgrammeCode: "24",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "26",
    ProgrammeName: "Power Electronics",
    ProgrammeCode: "43",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "27",
    ProgrammeName: "Electrical Machine & Drives",
    ProgrammeCode: "44",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "28",
    ProgrammeName: "Systems and Signal Processing",
    ProgrammeCode: "45",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "29",
    ProgrammeName: "Communication Engineering & Signal Processing",
    ProgrammeCode: "46",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "30",
    ProgrammeName: "Computers and Communication Engineering",
    ProgrammeCode: "49",
    Course: "M.Tech",
    Duration: "2 Years",
  },
  {
    SNo: "31",
    ProgrammeName: "Pharm. D (PB)",
    ProgrammeCode: "01",
    Course: "Pharm.D",
    Duration: "6 Years",
  },
  {
    SNo: "32",
    ProgrammeName: "Pharmaceutical Chemistry",
    ProgrammeCode: "02",
    Course: "M.Pharmacy",
    Duration: "2 Years",
  },
  {
    SNo: "33",
    ProgrammeName: "Pharmaceutics",
    ProgrammeCode: "03",
    Course: "M.Pharmacy",
    Duration: "2 Years",
  },
  {
    SNo: "34",
    ProgrammeName: "Pharmaceutical Analysis & Quality Assurance",
    ProgrammeCode: "04",
    Course: "M.Pharmacy",
    Duration: "2 Years",
  },
  {
    SNo: "35",
    ProgrammeName: "Bio-Technology",
    ProgrammeCode: "05",
    Course: "M.Pharmacy",
    Duration: "2 Years",
  },
  {
    SNo: "36",
    ProgrammeName: "Pharmacy Practice Course",
    ProgrammeCode: "08",
    Course: "M.Pharmacy",
    Duration: "2 Years",
  },
  {
    SNo: "37",
    ProgrammeName: "Pharmaceutical Analysis and Quality Control",
    ProgrammeCode: "12",
    Course: "M.Pharmacy",
    Duration: "2 Years",
  },
  {
    SNo: "38",
    ProgrammeName: "Quality Assurance and Regularity Affairs",
    ProgrammeCode: "15",
    Course: "M.Pharmacy",
    Duration: "2 Years",
  },
  {
    SNo: "39",
    ProgrammeName: "Agribusiness Management/ Entrepreneurship",
    ProgrammeCode: "01",
    Course: "MBA",
    Duration: "2 Years",
  },
  {
    SNo: "40",
    ProgrammeName: "Master in Hospital Administration",
    ProgrammeCode: "02",
    Course: "MBA",
    Duration: "2 Years",
  },
  {
    SNo: "41",
    ProgrammeName: "Logistics and Supply Chain Management",
    ProgrammeCode: "03",
    Course: "MBA",
    Duration: "2 Years",
  },
  {
    SNo: "42",
    ProgrammeName: "Big Data Analysis",
    ProgrammeCode: "04",
    Course: "MBA",
    Duration: "2 Years",
  },
  {
    SNo: "43",
    ProgrammeName: "Digital Marketing",
    ProgrammeCode: "05",
    Course: "MBA",
    Duration: "2 Years",
  },
  {
    SNo: "44",
    ProgrammeName: "MBA(Pharmaceutical Management)",
    ProgrammeCode: "08",
    Course: "MBA",
    Duration: "2 Years",
  },
];
